import { useIntl } from 'react-intl';

import { useFeatureFlags } from 'common/hooks';
import useUser from 'common/hooks/useUser';
import { EntityType, FeatureType } from 'common/types';

export const useIsRefundOverviewEnabled = (entityType: EntityType | FeatureType, entityId: string) => {
  const featureFlagName = 'merchant_admin_refund_overview';
  const { user, isEmployee } = useUser();
  const { locale } = useIntl();

  const { data: featureFlags, isLoading } = useFeatureFlags([featureFlagName], {
    user_id: user?.id || '',
    user_email: user?.email || '',
    user_country: user?.country || '',
    is_employee: isEmployee,
    locale,
    feature: entityType,
    feature_id: entityId,
  });

  return {
    isLoading,
    isRefundOverviewEnabled: featureFlags?.[featureFlagName] === 'on',
  };
};
